import React, { Component, Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HeaderBack from '../components/HeaderBack';
import CardItems from 'components/components/common/cards/CardItems';
import mergeErrors from 'components/helpers/mergeErrors';
import axios from 'components/AppRequest';
import LoadingSpinner from 'components/components/common/LoadingSpinner';
import { connect } from 'react-redux';
import {
  setCardIdInReservationEdit,
  createSuccessNotification,
  createErrorNotification,
} from 'components/actions/serviceActions';
import TransHelper from 'components/common/translations/TransHelper';
import T from 'components/common/translations/Translate';
import { STRIPE_PK } from 'components/windowEnvs';

class MyCards extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      csk: null,
      cardErrors: null
    };
    this.cardElementObject = null;
    this.cardItemsRef = React.createRef();
  }

  componentDidMount() {
    this.stripe = Stripe(STRIPE_PK);
    this.setState({ isLoading: true });
    axios.post('/pwa/cards/create-setup-intent', {})
      .then(response => {
        var csk = response.data.csk;
        this.setState({ csk });
        this.mountStripe();
        this.setState({ isLoading: false });
        // this.cardItemsRef.current.getWrappedInstance().fetchUserCards();
      })
      .catch(err => {
        console.error(err);
        this.setState({ isLoading: false });
      });
  }

  mountStripe = () => {
    var stripeContainer = document.getElementById("stripe-container");
    var stripeStyles = {
      base: {
        color: '#32325d',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    };

    var elements = this.stripe.elements();
    var cardElement = elements.create(
      'card',
      {
        hidePostalCode: true,
        style: stripeStyles
      },
    );
    cardElement.mount('#card-element');
    stripeContainer.style.display = "block";
    this.cardElementObject = cardElement;
  }

  trans = (key, prefix = 'content.account.card') => {
    return TransHelper.translate(this.props.locale, prefix + '.' + key);
  }

  transNotify = (type) => {
    return this.trans(type, 'content.notifications.cards');
  }

  submitFormAddCard = (e) => {
    this.setState({ isLoading: true });
    e.preventDefault();
    this.stripe.handleCardSetup(
      this.state.csk, this.cardElementObject, {
        payment_method_data: {
          billing_details: { name: this.props.loggedCustomer.name }
        }
      }
    ).then(result => {
      if (result.error) {
        // Display error.message in your UI.
        this.setState({ cardErrors: result.error.message });
        this.setState({ isLoading: false });
      } else {
        // The setup has succeeded. Display a success message.
        this.createCardInPanel(result);
      }
    });
  }

  createCardInPanel = (paymentResult) => {
    var params = {
      data: {
        paymentMethodId: paymentResult.setupIntent.payment_method
      }
    };
    axios.post('/pwa/cards/create-card', params)
      .then(response => {
        this.props.createSuccessNotification({
          message: this.transNotify('success')
        });
        this.setState({ isLoading: false });
        //getWrappedInstance() - cause connect()
        this.cardElementObject.clear();
        this.cardItemsRef.current.getWrappedInstance().fetchUserCards();
      })
      .catch(err => {
        console.log("err", err);
        this.props.createErrorNotification({
          title: this.transNotify('error'),
          message: mergeErrors(err.response.data.errors),
        });
        this.setState({ isLoading: false });
      });
  }

  render() {
    const { cardErrors, isLoading } = this.state;
    return (
      <div className="content content--bg" style={{ padding: '0' }}>

        <div className="grid-layout">
          <div className="grid-layout__item grid-layout__item--desc grid-layout__item--middle grid-layout__item--circle">

            <HeaderBack locale={this.props.locale} />

            <div className="content__desc">
              <h2><T>content.account.card.title</T></h2>

              <p className="security" style={{ fontSize: '14px' }}>
                <span>
                  <FontAwesomeIcon
                    icon={['fas', 'lock']}
                  /><T>content.account.card.stripeTitle</T>
                </span>
              </p>
              <CardItems
                isMyAccount
                ref={this.cardItemsRef}
                selectedCardId={this.props.selectedCardId}
                setCardId={this.props.setCardIdInReservationEdit}
              />
            </div>
          </div>

          <div className="grid-layout__item grid-layout__item--desc grid-layout__item--arrow grid-layout__item--middle grid-layout__item--light">
            <div className="content__desc">
              <h2><T>content.account.card.addNewCardTitle</T></h2>
              <form className="form-cards">
                <fieldset>
                  <div className="payments payments--style-reset">
                    <div
                      id="stripe-container"
                      style={{ display: "none", margin: "0 0 20px 0" }}
                      className="form-row"
                    >
                      <div id="card-element"></div>
                      {cardErrors && (
                        <div id="card-errors" role="alert">{cardErrors}</div>
                      )}
                    </div>
                  </div>

                  {isLoading ?
                    <LoadingSpinner className="button button--expand" />
                    :
                    <button
                      type="submit"
                      className="button button--expand"
                      onClick={this.submitFormAddCard}
                    >
                      <T>content.account.card.addCardButton</T>
                    </button>
                  }
                </fieldset>
              </form>

            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    selectedCardId: state.service.paramsForReservationUpdate.selectedCardId,
    locale: state.app.locale,
    loggedCustomer: state.app.customer,
  };
};

export default connect(
  mapStateToProps,
  { setCardIdInReservationEdit, createSuccessNotification, createErrorNotification }
)(MyCards);
